import { useMutation } from '@apollo/client';

import UpdateLearnerOccupationPreferences from 'bundles/onboarding-common/queries/UpdateLearnerOccupationPreferences.graphql';
import type {
  UpdateLearnerOccupationPreferencesMutation,
  UpdateLearnerOccupationPreferencesMutationVariables,
} from 'bundles/onboarding-common/queries/__generated__/UpdateLearnerOccupationPreferences';
import type { SelectedRole } from 'bundles/onboarding-common/types';

const useUpdateLearnerOccupationPreferences = () => {
  const [updateLearnerOccupationPreferencesMutation] = useMutation<
    UpdateLearnerOccupationPreferencesMutation,
    UpdateLearnerOccupationPreferencesMutationVariables
  >(UpdateLearnerOccupationPreferences, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
  });

  const updateLearnerOccupationPreferences = async (answers?: SelectedRole[] | null) => {
    const occupationPreferences: UpdateLearnerOccupationPreferencesMutationVariables['occupationPreferences'] =
      answers?.flatMap<{ occupation: { name: string } } | { occupation: { id: string } }>((answer) => {
        const id = answer.id;
        const name = answer.name;
        const type = answer.type;
        if (type === 'CUSTOM') {
          return [{ occupation: { name } }];
        } else if (type === 'UNSURE') {
          // TODO: Handle UNSURE type
          return [];
        } else {
          return [{ occupation: { id } }];
        }
      }) || [];

    const { errors, data } = await updateLearnerOccupationPreferencesMutation({
      variables: {
        occupationPreferences,
      },
    });
    if (errors) {
      return errors;
    }

    if (data?.LearnerProfile_PatchWorkPreferences.__typename === 'LearnerProfile_PatchFailure') {
      return data?.LearnerProfile_PatchWorkPreferences.errors.map((error) => error.message);
    }

    return undefined;
  };

  return { updateLearnerOccupationPreferences };
};

export default useUpdateLearnerOccupationPreferences;
